'use strict';

const CustomError=require('pulsar-utils/dist-es6/customError');let

AccessDeniedError=class AccessDeniedError extends CustomError{
constructor(){
super('AccessDeniedError');
}};


module.exports=AccessDeniedError;
//# sourceMappingURL=accessDeniedError.js.map
